import axios from 'axios'

export class Berechtigung{
    static async get(konvKey){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/berechtigungenByKonvKey/${konvKey}`
            );

            // Hier kannst du die Daten weiterverarbeiten oder in der Komponente verwenden
            var berechtigungen = response.data;
            console.log(response);
            localStorage.setItem('Berechtigungen', JSON.stringify(berechtigungen));
            return berechtigungen;
        } catch (err) {
            console.error(err);
            let local = this.getLocal();
            if(local == false || local == "" || local.length == 0){
                return false;
            } else{
                return local;
            }
        }
    }

    static getLocal(){
        return JSON.parse(localStorage.getItem('Berechtigungen'));
    }

    static async getFreischaltMailsByKonvKey(konvKey){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/freischaltEmails/${konvKey}`
            );
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
